// extracted by mini-css-extract-plugin
export default {"noResultWrapper":"noResultTable_noResultWrapper__wVeTY"};